import React, { useEffect, useMemo, useState } from "react"
import { enumUtil } from "../../../../../utils/Enum"
import NotificationHandler from "../../../../../utils/NotificationHandler"
import FormValidator from "../../../../../utils/FormValidator"
import isNull from "../../../../../utils/NullChecking"
import { ServerRequestProtected, ServerRequestPublic } from "../../../../../utils/ServerDataRequest"
import Loader from "../../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../../General/DeleteConfirmation"
import Audit from "../../../../General/Audit"
import ModalFooter from "../../../../Setup/Shared/ModalFooter"
import format from "date-fns/format"
import handleNumericCheck from "../../../../../utils/HandleNumericKeys"
import SuperSearchList from "../../../../shared/SuperSearch/SuperSearchList"
import { useSelector } from "react-redux"
import ModalHeader from "../../../../Setup/Shared/ModalHeader"
import moment from "moment/moment"
import DateValidator from "../../../../../utils/DateValidator"
import FormatDate from "../../../../shared/DateFormatter"
import DatePicker from '../../../../General/DatePicker';
import { AuthorizationFrequency } from "../../../../../utils/Constants"
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { saveAs } from "file-saver"
import { Form } from "react-bootstrap"
import OpenQuickPopup from "../../../../shared/OpenQuickPopup/OpenQuickPopup"
import DiagnosisSearch from "../../../../shared/AdvanceSearches/DiagnosisSearch"
import ProcedureSearch from "../../../../shared/AdvanceSearches/ProcedureSearch"
import { FindFirstChild } from "../../../../../utils/FindMenuOption"
import AuthorizedUpdatePopup from "./AuthorizedUpdatePopup"
import Pdfdetail from "../../../../General/pdfdetail"
import { PdfIcon } from "../../../../shared/IconsComponent/icons"
import SuperICDandCPTSearch from "../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch"
import AddNewDiagnosis from "../../../../Setup/Coding/DiagnosisCode/AddNewDiagnosis"
import AddNewProcedureCodes from "../../../../Setup/Coding/ProcedureCode/AddNewProcedureCodes"
const AddNewAuthForPractice = (props) => {
    let IsEditAllowed = FindFirstChild('Patient', 'Authorization')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Patient', 'Authorization')?.IsDeleted
    let RecentICDs = useSelector(state => state.CodesDropDownReducer.RecentICD)
    let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)


    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Claim = enumUtil.controller.Claim
    const API_URL_Wasabi = enumUtil.controller.Wasabi

    const { IsOpenAuthorization, onClose, InsuranceListModal, isReadOnly, onDeleteInsurance, npiModal, proceedHeader, onCloseProocedNpi, type, PatientID, UpdateFiledStatus, authModal, DataImportMenu, handleProcessPendingData } = { ...props }

    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [isOpenAuthorized, setisOpenAuthorized] = useState(false);
    const [claimCounts, setclaimCounts] = useState();
    const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [NpiRegistryNumber, setNpiRegistryNumber] = useState('');
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = !isNull(PatientID) ? PatientID : PateintIDR?.data?.id


    const [OCRFile, setOCRFile] = useState('')
    const [OCRFileName, setOCRFileName] = useState('')
    // const AuthorizationType = [
    //     { value: '', display: 'Select Type' },
    //     { value: 'Medical', display: 'Medical' },
    //     { value: 'Dental', display: 'Dental' },
    //     { value: 'Surgical', display: 'Surgical' },
    //     { value: 'Therapy', display: 'Therapy' },
    // ]
    const AuthorizationStatus = [
        { value: '', display: '' },
        { value: 'Active', display: 'Active' },
        { value: 'Expired', display: 'Expired' },
        { value: 'Expiring', display: 'Expiring' },
    ]
    let Authorization_Modal = {
        AuthBasedOn: '',
        AuthorizationType: "",
        PatientID: "",
        PatientInsuranceID: "",
        InsuranceID: "",
        ProviderID: "",
        LocationID: "",
        DiagnosisCode1: "",
        DiagnosisCode2: "",
        DiagnosisCode3: "",
        DiagnosisCode4: "",
        ProcedureCode: "",
        AuthorizationNumber: "",
        StartDate: null,
        EndDate: null,
        AuthorizationStatus: "Active",
        VisitsAllowed: "",
        Remarks: "",
        AuthorizeUnits: "",
        UtilizedUnits: "",
        RemainingUnits: "",
        UnitsFrequency: "",
        InsuranceType: "",
        ProviderFeeScheduleID: "",
        Status: '',
        Frequency: 'EntirePeriod',
        AuthorizationDocument: '',
        FileName: '',
        AdditionalCPTCode: '',
        ProcedureCodeID: "",
        CountyAmount: "",
        Notes: ""
    }

    let valModal = {}
    // validation modal 
    let ValidationModal = {
        InusranceIDVal: "",
        ProcedureCodeVal: "",
        AuthorizationNumberVal: "",
        UnitsFrequencyVal: "",
        AuthorizedUnitLengthVal: "",
        StartDateval: "",
        EndDateVal: "",
        AuthorizedUnitsVal: ""
    }

    let AuthFile_Validation = {
        UploadedFile: ''
    }
    let AuthFile_Val_Modal = '';
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [mainAuthorizationModal, setmainAuthorizationModal] = useState(Authorization_Modal);
    const [AuthorizationSaveUpdateModal, setAuthorizationSaveUpdateModal] = useState({})
    const [AuthorizationValidationModal, setAuthorizationValidationModal] = useState(ValidationModal);
    const [AuthFileValidation, setAuthFileValidation] = useState(AuthFile_Validation);
    const [AuthorizationID, setAuthorizationID] = useState();
    const [isSaved, setIsSaved] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [UpdateAuthorizationNumber, setUpdateAuthorizationNumber] = useState(false);
    const [NewAuthorizationNumber, setNewAuthorizationNumber] = useState(null);
    const [onInsuranceSave, setOnInsuranceSave] = useState(false)
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })
    const [icdBody, setIcdBody] = useState({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": '' })
    const [pdfFile, setPdfFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [modalActive, setModalActive] = useState(false)
    const [is, setIs] = useState(true);
    const [curSelectedICD, setcurSelectedICD] = useState('')
    const [selectedClaimId, setSelectedClaimID] = useState([])
    const [isOpenICDSearch, setisOpenICDSearch] = useState(false);
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [isOpenCPT, setisOpenCPT] = useState(false);
    const [AdditionalCPT, setAdditionalCPT] = useState('')
    const [curIndex, setCurIndex] = useState()
    const [popup, setPopup] = useState(<></>);
    const [previousAuthorizationNumber, setPreviousAuthorizationNumber] = useState('');
    const [OCRType, setOCRType] = useState(null);
    let icd1 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode1 + ""} name={'ICD1'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let icd2 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode2 + ""} name={'ICD2'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let icd3 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode3 + ""} name={'ICD3'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let icd4 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode4 + ""} name={'ICD4'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let valoModalDate = {}
    let dateValidation = {
        DateVal: '',
    }

    const ApplyFileChanges = (OCRData) => {
        const mainModal = { ...mainAuthorizationModal }
        const saveModal = { ...AuthorizationSaveUpdateModal }

        mainModal['AuthorizationNumber'] = OCRData?.authorizationNo;
        mainModal['StartDate'] = OCRData?.startDate;
        mainModal['EndDate'] = OCRData?.endDate;
        mainModal['DiagnosisCode1'] = OCRData?.DiagnosisCode1 ?? '';
        mainModal['DiagnosisCode2'] = OCRData?.DiagnosisCode2 ?? '';
        mainModal['DiagnosisCode3'] = OCRData?.DiagnosisCode3 ?? '';
        mainModal['DiagnosisCode4'] = OCRData?.DiagnosisCode4 ?? '';
        mainModal['ProcedureCode'] = OCRData?.procedureCode;
        mainModal['AdditionalCPTCode'] = "";
        mainModal['AuthorizeUnits'] = OCRData?.totalProcedureQty;

        mainModal['Mon'] = OCRData?.mon
        mainModal['Tue'] = OCRData?.tue
        mainModal['Wed'] = OCRData?.wed
        mainModal['Thu'] = OCRData?.thu
        mainModal['Fri'] = OCRData?.fri
        mainModal['Sat'] = OCRData?.sat
        mainModal['Sun'] = OCRData?.sun

        // mainModal['ScheduleUnits'] = "";
        // mainModal['RemainingUnits'] = "";
        // mainModal['UtilizedUnits'] = "";
        // mainModal['AuthorizationStatus'] = OCRData?.authStatus;
        mainModal['UnitsFrequency'] = OCRData?.unitsFrequency;

        saveModal['AuthorizationNumber'] = OCRData?.authorizationNo;
        saveModal['StartDate'] = OCRData?.startDate;
        saveModal['EndDate'] = OCRData?.endDate;
        saveModal['DiagnosisCode1'] = OCRData?.DiagnosisCode1 ?? '';
        saveModal['DiagnosisCode2'] = OCRData?.DiagnosisCode2 ?? '';
        saveModal['DiagnosisCode3'] = OCRData?.DiagnosisCode3 ?? '';
        saveModal['DiagnosisCode4'] = OCRData?.DiagnosisCode4 ?? '';
        saveModal['ProcedureCode'] = OCRData?.procedureCode;
        saveModal['AdditionalCPTCode'] = "";
        saveModal['AuthorizeUnits'] = OCRData?.totalProcedureQty;

        saveModal['Mon'] = OCRData?.mon
        saveModal['Tue'] = OCRData?.tue
        saveModal['Wed'] = OCRData?.wed
        saveModal['Thu'] = OCRData?.thu
        saveModal['Fri'] = OCRData?.fri
        saveModal['Sat'] = OCRData?.sat
        saveModal['Sun'] = OCRData?.sun
        // saveModal['ScheduleUnits'] = "";
        // saveModal['RemainingUnits'] = "";
        // saveModal['UtilizedUnits'] = "";
        // saveModal['AuthorizationStatus'] = OCRData?.authStatus;
        saveModal['UnitsFrequency'] = OCRData?.unitsFrequency;

        setmainAuthorizationModal(mainModal);
        setAuthorizationSaveUpdateModal(saveModal);

    }

    const CloseRegistry = (data) => {
        setIs(true)
        setIsOpenRegistry(false)
    }
    const [error, setError] = useState(dateValidation);
    // find practice Data by id 
    useEffect(() => {
        if (props.AuthorizationID != null) {
            setAuthorizationID(props.AuthorizationID)
            setDel(true)
        } else {
            if (type === 'Wizard') {
                if (!onInsuranceSave) {
                    setAuthorizationID(0);
                    setDel(false)
                } else {
                    setDel(true)
                }
            } else {
                if (InsuranceListModal.length > 0) {
                    if (!isNull(InsuranceListModal[0]?.value)) {
                        setmainAuthorizationModal({ ...mainAuthorizationModal, InsuranceID: InsuranceListModal[0]?.value + "", PatientInsuranceID: InsuranceListModal[0].InsuranceName })
                        setOCRType(InsuranceListModal[0].AuthOCRType)
                    }
                }
                setAuthorizationSaveUpdateModal({ ...AuthorizationSaveUpdateModal, AuthorizationStatus: 'Active', Frequency: 'EntirePeriod', PatientInsuranceID: props.PatientInsuranceID + "" })
                if (!onInsuranceSave) {
                    setAuthorizationID(0);
                    setDel(false)
                } else {
                    setDel(true)
                }
            }

        }
    }, [InsuranceListModal])
    useEffect(() => {
        setIs(true)
        if (!isNull(AuthorizationID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/PatientAuthByID", 'post', {
                "ID": AuthorizationID,
                "TableName": enumUtil.enumAPITableName.PatientAuthorization
            }).then((response) => {
                setIsLoading(false)
                setmainAuthorizationModal({
                    ...response.PatientAuthorization,
                    ProviderFeeScheduleID: response.PatientAuthorization.CountyName,
                    InsuranceID: response.PatientAuthorization.InsuranceID + "",
                    PatientInsuranceID: response.PatientAuthorization.InsuranceName,
                    StartDate: !isNull(response.PatientAuthorization.StartDate) ? FormatDate(response.PatientAuthorization.StartDate) : null,
                    EndDate: !isNull(response.PatientAuthorization.EndDate) ? FormatDate(response.PatientAuthorization.EndDate) : null
                })
                if (previousAuthorizationNumber === "") {
                    setPreviousAuthorizationNumber(response.PatientAuthorization.AuthorizationNumber);
                }
                setAdditionalCPT(response.PatientAuthorization?.AdditionalCPTCodeID);
                setclaimCounts(response.PatientAuthorization?.ClaimCount)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }, [isSaved, AuthorizationID])
    const handleAuthorizationChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase();
        }
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };
        if (name === 'AuthorizeUnits') {
            modal['UnitsFrequency'] = value;
            saveModal['UnitsFrequency'] = value;
        }
        modal[name] = value;
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value;
            }
        }
        setmainAuthorizationModal(modal);
        setAuthorizationSaveUpdateModal(saveModal);
    };
    const handleDropdwonChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };
        modal[name] = value
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setAuthorizationSaveUpdateModal(saveModal)
    }

    const AuthorizationFileValidation = async () => {
        let validationModal = {
            UploadedFile: FormValidator(OCRFileName, enumUtil?.enumValidationType?.Required, 'File'),

        }
        AuthFile_Val_Modal = validationModal
        setAuthFileValidation(validationModal);
    }

    const AuthorizationValidation = async () => {
        let ValidationModal = {
            InusranceIDVal: FormValidator(
                mainAuthorizationModal.PatientInsuranceID,
                enumUtil.enumValidationType.Required,
                'Insurance Name',
            ),
            ProcedureCodeVal: FormValidator(
                mainAuthorizationModal.ProcedureCode,
                enumUtil.enumValidationType.Required,
                'CPT Code',
            ),
            AuthorizationNumberVal: FormValidator(
                mainAuthorizationModal.AuthorizationNumber,
                enumUtil.enumValidationType.Required,
                'Authorization Number',
            ),
            UnitsFrequencyVal: FormValidator(
                mainAuthorizationModal.UnitsFrequency,
                enumUtil.enumValidationType.Required,
                'Unit(s) Per Frequency',
            ),
            AuthorizedUnitsVal: FormValidator(
                mainAuthorizationModal.AuthorizeUnits,
                enumUtil.enumValidationType.Required,
                'Authorize Units',
            ),
            StartDateval: FormValidator(
                mainAuthorizationModal.StartDate,
                enumUtil.enumValidationType.Required,
                "Start Date"
            ),
            EndDateVal: FormValidator(
                mainAuthorizationModal.EndDate,
                enumUtil.enumValidationType.Required,
                "End Date"
            )
        }
        await setAuthorizationValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveAuthorization = async () => {
        await validateDates()
        await AuthorizationValidation()
        let validation1 = FormValidator([valoModalDate], enumUtil.enumValidationType.NullCheck)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation || validation1) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        }
        else {
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientAuthorization,
                ID: AuthorizationID + "",
                data: { ...AuthorizationSaveUpdateModal, PatientID: PateintIDR + "" },
                ListOfData: []
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SavePatientAuthorization", 'post', saveModal).then((response) => {
                setIsSaved(Math.random())
                setIsLoading(false)
                if (type === "Wizard") {
                    UpdateFiledStatus()
                }
                if (!isNull(response.id)) {
                    setAuthorizationSaveUpdateModal(response.AuthorizationNumber)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    setAuthorizationID(response.id)
                    setOnInsuranceSave(true)
                }
                let NewAuthorizationNumber = AuthorizationSaveUpdateModal?.AuthorizationNumber;
                setNewAuthorizationNumber(NewAuthorizationNumber)
                if (AuthorizationID !== 0) {
                    if (claimCounts > 0 && NewAuthorizationNumber && NewAuthorizationNumber !== previousAuthorizationNumber) {
                        setUpdateAuthorizationNumber(true);
                        return;
                    }
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    const SetAuthorizationName = () => {
        if (mainAuthorizationModal.InsuranceName) {
            return (
                <p className="heading sm">{mainAuthorizationModal.InsuranceName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add Authorization</p>
            )
        }
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="bi bi-trash-fill"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.PatientAuthorization} ID={AuthorizationID} onClose={onDeleteInsurance} />
    }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }
    const onCloseNpi = () => { setIsOpenRegistry(false) }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={AuthorizationID + ""} TableName={enumUtil.enumAPITableName.PatientAuthorization} />
    }
    let PopupScreen = "";
    if (isOpenRegistry) {
        PopupScreen = <Pdfdetail isOpenRegistry={isOpenRegistry} onClosee={CloseRegistry} OCRFile={OCRFile} OCRType={OCRType} ApplyFileChanges={ApplyFileChanges} onCloseNpi={onCloseNpi} AuthMainModal={mainAuthorizationModal} LoadCounties={() => { }} ClassName='npi-panel npi-open npi_detail_popup' />
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal }
        modal[type] = FormatedDate
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setAuthorizationSaveUpdateModal(saveModal)
    }
    const validateDates = async () => {
        let ValidationModal = {
            DateVal: DateValidator(
                mainAuthorizationModal.StartDate,
                mainAuthorizationModal.EndDate,
                enumUtil.enumValidationType.StartEndDate,
                'Date',
            ),
        }
        await setError(ValidationModal)
        valoModalDate = ValidationModal
    };
    const handleSelectedData = async (selectedData, name, type) => {
        setIs(true)
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'PatientInsuranceID') {
                modal[name] = selectedData.InsuranceName
                modal['InsuranceID'] = selectedData.value + ""
                saveModal[name] = selectedData.PatientInsuranceID + "";
                setOCRType(selectedData?.AuthOCRType)
            } else {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.value + "";
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'DiagnosisCode1') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode1ID'] = selectedData.value + "";
            } else if (name === 'DiagnosisCode3') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode3ID'] = selectedData.value + "";
            } else if (name === 'DiagnosisCode2') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode2ID'] = selectedData.value + "";
            } else if (name === 'DiagnosisCode4') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode4ID'] = selectedData.value + "";
            }
            else if (name === 'ProcedureCode') {
                modal[name] = selectedData.display
                modal['ProcedureCodeID'] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['ProcedureCodeID'] = selectedData.value + "";
            }
            else if (name === 'AdditionalCPTCode') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['AdditionalCPTCodeID'] = selectedData.value + "";
            }
        } else {
            if (name === 'DiagnosisCode1') {
                saveModal['DiagnosisCode1ID'] = "";
            } else if (name === 'DiagnosisCode3') {
                saveModal['DiagnosisCode3ID'] = "";
            } else if (name === 'DiagnosisCode2') {
                saveModal['DiagnosisCode2ID'] = "";
            } else if (name === 'DiagnosisCode4') {
                saveModal['DiagnosisCode4ID'] = "";
            } else if (name === 'ProcedureCode') {
                saveModal[name] = "";
                saveModal['ProcedureCodeID'] = "";
            } else if (name === 'AdditionalCPTCode') {
                saveModal[name] = "";
                saveModal['AdditionalCPTCodeID'] = "";
            }
            modal[name] = ''
            saveModal[name] = ''
        }
        setAuthorizationSaveUpdateModal(saveModal)
        setmainAuthorizationModal(modal)
        return selectedData
    }
    const handleSelectDiagnosisData = (selectedData, name, type, isRecICD) => {
        let data
        if (isRecICD === true) {
            data = { value: selectedData[0].DiagnosisCodeID, display: selectedData[0].DiagnosisCode }
        } else {
            data = selectedData
        }
        let modal = { ...mainAuthorizationModal };
        if (type === 'client' && !isNull(data)) {
            if (name === 'BillingProviderID') {
                modal[name] = data.display
                AuthorizationSaveUpdateModal[name] = data.value;
            }
        } else if (type === 'server' && !isNull(data)) {
            modal[name] = data.display
            AuthorizationSaveUpdateModal[name] = data.display + "";
            AuthorizationSaveUpdateModal[name + 'ID'] = data.value + "";
        } else {
            modal[name] = ''
            AuthorizationSaveUpdateModal[name] = ''
        }
        setmainAuthorizationModal(modal)
        // setICDvalidationModal(myVal)
        let valList = []
        const variableName = name
        const lastIndex = variableName.lastIndexOf('Code');
        let codeNumber
        if (lastIndex !== -1) {
            codeNumber = variableName.slice(3, lastIndex);
        } else {
            console.log('Code not found in the variable name');
        }

        return selectedData
    }
    const [isFileChanged, setIsFileChanged] = useState(false)

    const handleImageChange = (e) => {
        setIsFileChanged(true)
        const { name, files } = e.target;
        const file = files[0];
        const modalCopy = { ...mainAuthorizationModal };
        const saveModalCopy = { ...AuthorizationSaveUpdateModal };
        if (name === 'AuthorizationDocument') {
            modalCopy['FileName'] = file.name;
            saveModalCopy['FileName'] = file.name;
        }
        setmainAuthorizationModal(modalCopy);
        const reader = new FileReader();

        reader.onloadend = (event) => {
            const value = reader.result.toString();
            modalCopy[name] = value;
            setmainAuthorizationModal(modalCopy);
            for (const property in modalCopy) {
                if (name === property) {
                    saveModalCopy[name] = event.target.result.split("base64,")[1];
                }
            }
        };
        reader.readAsDataURL(file);
        setAuthorizationSaveUpdateModal(saveModalCopy);

    }
    const handleImageChangeOCR = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        const modalCopy = { ...mainAuthorizationModal };
        const saveModalCopy = { ...AuthorizationSaveUpdateModal };

        modalCopy['FileName'] = file.name;
        saveModalCopy['FileName'] = file.name;

        setOCRFileName(file.name)
        const reader = new FileReader();
        reader.onloadend = (event) => {
            const value = reader.result.toString();
            saveModalCopy[name] = event.target.result.split("base64,")[1];
            setOCRFile(event.target.result.split("base64,")[1])
        }
        reader.readAsDataURL(file);

        setmainAuthorizationModal(modalCopy);
        setAuthorizationSaveUpdateModal(saveModalCopy);
    }
    const ViewPdf = (data) => {
        setPdfFile(null)
        setTxtFile(null)
        setImgFile(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": mainAuthorizationModal.AuthorizationDocument
        }, 'Download').then((response) => {
            setIsLoading(false)
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setTxtFile(content);
                };
                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/jepg') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setImgFile(objectURL)
            } else if (response.type === 'application/tiff') {

            }
            else {
                let file = new Blob([response]);
                const fileUrl = URL.createObjectURL(file);
                setPdfFile(fileUrl)
            }
            setModalActive(true)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }
    const handleRemoveImage = (type) => {
        if (type === 'AuthorizationDocument') {
            setmainAuthorizationModal({
                ...mainAuthorizationModal,
                AuthorizationDocument: null,
                FileName: '',
            });
            setAuthorizationSaveUpdateModal({
                ...AuthorizationSaveUpdateModal,
                AuthorizationDocument: null,
                FileName: '',
            });
        } else if (type === "OCRFile") {
            setOCRFile("")
            setOCRFileName("")
            setmainAuthorizationModal({
                ...mainAuthorizationModal,
                AuthorizationDocument: null,
                FileName: '',
            });
            setAuthorizationSaveUpdateModal({
                ...AuthorizationSaveUpdateModal,
                AuthorizationDocument: null,
                FileName: '',
            });
        }
    }
    const DownloadFile = () => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": mainAuthorizationModal.AuthorizationDocument
        }, "Download",)
            .then((response) => {
                setIsLoading(false)
                let blob = new Blob([response]);
                saveAs(blob, mainAuthorizationModal.FileName);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    const handleOpenCPTCode = (name) => {
        setCurIndex(name)
        setisOpenCPT(true)
    }
    const onCloseCPT = () => {
        setisOpenCPT(false)
        setSelectedRows(new Set())
    }
    const handleOpenICD = (name) => {
        setcurSelectedICD(name)
        setisOpenICDSearch(true)
    }
    const onCloseICD = () => {
        setisOpenICDSearch(false)
    }
    const handleDiagnosisChange = (e) => {
        setIs(false)
        let { name, value } = e.target
        let modal = { ...mainAuthorizationModal }
        let saveModal = { ...AuthorizationSaveUpdateModal }
        modal[name] = value
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }

        if (name === 'ProcedureCode' || name === 'AdditionalCPTCode') {
            setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })

        } else if (name === 'DiagnosisCode1' || name === 'DiagnosisCode2' || name === 'DiagnosisCode3' || name === 'DiagnosisCode4') {
            setIcdBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": value })

        }
        setmainAuthorizationModal(modal)
    }
    const handleServiceLineChange = (e, id, index, type) => {
        setIs(true)
        let { name, value } = e.target
        let modal = { ...mainAuthorizationModal }
        modal[name] = value
        let saveModal = { ...AuthorizationSaveUpdateModal }
        modal[name] = value
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setAuthorizationSaveUpdateModal(saveModal)
        setIcdBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })
    };
    const handleSelecCPT = (cptCode, method) => {
        if (!isNull(cptCode)) {
            if (method === 'CPT') {
                let arr = [...cptCode];
                let data = arr.filter((item) => {
                    return item.ProcedureCodeID + "" === selectedClaimId + "";
                });
                if (curIndex === "AdditionalCPTCode") {
                    let modal = { ...mainAuthorizationModal }
                    let saveModal = { ...AuthorizationSaveUpdateModal }
                    modal['AdditionalCPTCode'] = data[0].ProcedureCode
                    saveModal['AdditionalCPTCode'] = data[0].ProcedureCode
                    saveModal['AdditionalCPTCodeID'] = data[0].ProcedureCodeID
                    setmainAuthorizationModal(modal)
                    setAuthorizationSaveUpdateModal(saveModal)
                } else {
                    handleServiceLineChange({ target: { name: 'ProcedureCode', value: data[0].ProcedureCode } }, curSelectedICD, 'server', true);
                    let selectedData = { value: data[0].ProcedureCodeID, display: data[0].ProcedureCode }
                }
            } else {
                let arr = [...cptCode];
                let data = arr.filter((item) => {
                    return item.ProcedureMacroID + "" === selectedClaimId + "";
                });

                // Assuming curIndex is defined somewhere
                // handleSuperSearchList(data, curIndex, 'ProcedureCode', true, method);
            }

            onCloseCPT();
        }
    };
    const onRowSelection = (listOfIds) => {
        const arrayOfIds = Array.from(listOfIds); // Convert the Set to an array
        const lastSelectedId = arrayOfIds[arrayOfIds.length - 1]; // Get the last element in the array
        setSelectedRows(new Set([lastSelectedId])); // Set the last selected ID as a new Set
        setSelectedClaimID(lastSelectedId);
    }
    const onRowSelectionPR = (listOfIds) => {
        const arrayOfIds = Array.from(listOfIds); // Convert the Set to an array
        const lastSelectedId = arrayOfIds[arrayOfIds.length - 1]; // Get the last element in the array
        setSelectedRows(new Set([lastSelectedId])); // Set the last selected ID as a new Set
        setSelectedClaimID(lastSelectedId);
    }
    const rowKeyGetter = (row) => {
        return row.DiagnosisCodeID;
    }
    const rowKeyGetterPR = (row) => {
        return row.ProcedureCodeID;
    }
    const handleSelectDiagnosis = (diagnosisCode) => {
        if (!isNull(diagnosisCode)) {
            let arr = [...diagnosisCode]
            let data = arr.filter((item) => {
                return item.DiagnosisCodeID + "" === selectedClaimId + ""
            })
            handleSelectDiagnosisData(data, curSelectedICD, 'server', true)
            onCloseICD()
        }
    }
    const handleNpiRegistry = async () => {

        await AuthorizationFileValidation();
        let validation = FormValidator([AuthFile_Val_Modal], enumUtil.enumValidationType.NullCheck)

        if (validation) {
            return
        }
        setIsOpenRegistry(true);
        setIsLoading(false);
        onCloseProocedNpi();
    }
    let ICDpopup = '';
    if (isOpenICDSearch) {
        ICDpopup = <DiagnosisSearch isOpenICDSearch={isOpenICDSearch} onCloseICD={onCloseICD} handleSelectDiagnosis={handleSelectDiagnosis} onRowSelection={onRowSelection} rowKeyGetter={rowKeyGetter} selectedRows={selectedRows} />
    }
    let ProcedureSerachPopup = '';
    if (isOpenCPT) {
        ProcedureSerachPopup = <ProcedureSearch isOpenCPT={isOpenCPT} onCloseCPT={onCloseCPT} handleSelecCPT={handleSelecCPT} onRowSelection={onRowSelectionPR} rowKeyGetter={rowKeyGetterPR} selectedRows={selectedRows} options={false} />
    }
    const handleAutorized = () => {
        setisOpenAuthorized(true)
        setUpdateAuthorizationNumber(false)
    }
    const handleAutorizedClose = () => {
        setUpdateAuthorizationNumber(false);
        setPreviousAuthorizationNumber(mainAuthorizationModal?.AuthorizationNumber);
    }
    const onCloseAuthorized = () => {
        setisOpenAuthorized(false);
        setPreviousAuthorizationNumber(mainAuthorizationModal?.AuthorizationNumber);
    }

    let AuthrizedPopup = "";
    if (isOpenAuthorized) {
        AuthrizedPopup = <AuthorizedUpdatePopup isOpenAuthorized={isOpenAuthorized} onClose={onCloseAuthorized} PrevAuthorization={previousAuthorizationNumber} UpdateAuthorization={NewAuthorizationNumber} AuthorizationID={AuthorizationID} AdditionalCPT={AdditionalCPT} />
    }


    // diagnosis popup

    const [isOpenNewDiagnosis, setisOpenNewDiagnosis] = useState(false)
    const [icdCode, setIcdCode] = useState()
    const [ActiveICDName, setActiveICDName] = useState('')
    const handleAddNewICD = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenNewDiagnosis(true)
    }
    const handleCloseICD = () => {
        setisOpenNewDiagnosis(false)
        setIcdCode()
        setActiveICDName('')
    }
    const handleOnSaveICD = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
        handleCloseICD()
    }
    let NewICDPopup = ''
    if (isOpenNewDiagnosis) {
        NewICDPopup = <AddNewDiagnosis isOpenDiagnosis={isOpenNewDiagnosis} onClose={handleCloseICD} Diagnosisvalue={icdCode} onDeleteProcedure={handleCloseICD} onDeleteDiagnosis={handleCloseICD} IsOpen={true} onICDSave={handleOnSaveICD} />
    }
    const [isOpenProcedureCode, setisOpenProcedureCode] = useState(false)
    const handleAddNewCPT = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenProcedureCode(true)
    }
    const handleCloseCPT = () => {
        setisOpenProcedureCode(false)
        setIcdCode()
        setActiveICDName('')
    }
    const handleOnSaveCPT = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
        handleCloseCPT()
    }
    let NewCPTPopup = ''
    if (isOpenProcedureCode) {
        NewCPTPopup = <AddNewProcedureCodes isOpenProcedure={isOpenProcedureCode} onClose={handleCloseCPT} ProcedureCode={icdCode} onDeleteProcedure={handleCloseCPT} handleOnSaveICD={handleOnSaveCPT} isOpenFromList={true} />
    }
    const AddnewAuth = () => {
        return (
            <>
                <div className="row row-gap-8">
                    <div className="col-md-6 mb-1 ar-multiple-br">
                        <div className={AuthorizationValidationModal.InusranceIDVal ? 'input form-group mb-0 error' : 'input form-group mb-0'}>
                            {/* <div className='input form-group mb-0'> */}
                            <label htmlFor="PatientInsuranceID">Payer<span className='req'>*</span></label>
                            <SuperSearchList
                                type="client"
                                id='PatientInsuranceID'
                                name='PatientInsuranceID'
                                searchValue={mainAuthorizationModal.PatientInsuranceID}
                                data={InsuranceListModal}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                inputError={AuthorizationValidationModal.InusranceIDVal}
                            />
                            {/* </div> */}
                            {AuthorizationValidationModal.InusranceIDVal}
                        </div>
                    </div>
                    <div className="col-md-6 mb-1">
                        <div className={AuthorizationValidationModal.AuthorizationNumberVal ? 'form-group input error' : 'input form-group'}>
                            <label htmlFor="AuthorizationNumber">Authorization #<span className='req'>*</span></label>
                            <input type="text"
                                className='form-control'
                                name="AuthorizationNumber"
                                id="AuthorizationNumber"
                                maxLength={50}
                                autoComplete="off"
                                value={mainAuthorizationModal.AuthorizationNumber}
                                onChange={handleAuthorizationChange}
                            />
                            {AuthorizationValidationModal.AuthorizationNumberVal}
                            {/* </div> */}
                        </div>
                    </div>
                    <div className='col-md-3 mb-1'>
                        {/* <div className={error.DateVal || AuthorizationValidationModal.StartDateval ? 'form-group input error' : 'input form-group'}> */}
                        <DatePicker
                            label={<span> Start Date <span className='req'>*</span> </span>}
                            className='mb-0'
                            value={mainAuthorizationModal.StartDate}
                            handleCalendarChangefunc={date => handleCalendarChange(date, 'StartDate')}
                            inputError={error.DateVal || AuthorizationValidationModal.StartDateval}
                        />
                        {/* </div> */}
                        {error.DateVal || AuthorizationValidationModal.StartDateval}
                    </div>
                    <div className="col-md-3 mb-1">
                        {/* <div className={error.DateVal || AuthorizationValidationModal.EndDateVal ? 'form-group input error' : 'input form-group'}> */}
                        <DatePicker
                            label={<span> End Date <span className='req'>*</span> </span>}
                            className='mb-0'
                            value={mainAuthorizationModal.EndDate}
                            handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate')}
                            portalId="root-portal"
                            inputError={error.DateVal || AuthorizationValidationModal.EndDateVal}
                        />
                        {/* </div> */}
                        {error.DateVal || AuthorizationValidationModal.EndDateVal}
                    </div>
                    <div className="col-md-3 ">
                        <div className={AuthorizationValidationModal.ProcedureCodeVal ? 'form-group input error' : 'form-group input mb-0'}>
                            <div className="d-flex justify-content-between">
                                <label>CPT <span className='req'>*</span></label>
                                {<i className='icon-Clip-path-group' onClick={() => handleOpenCPTCode('ProcedureCode')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentCPTs}
                                PatDxData={[]}
                                id='CPT'
                                name='ProcedureCode'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.ProcedureCode}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                                method='post'
                                postBody={cptBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                inputError={AuthorizationValidationModal.ProcedureCodeVal}
                                isItemSelected={!isNull(mainAuthorizationModal.ProcedureCode) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                            {/* <SuperSearchList
                                type='server'
                                id='ProcedureCode'
                                name='ProcedureCode'
                                searchValue={mainAuthorizationModal.ProcedureCode}
                                ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                                method='post'
                                postBody={cptBody}
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // icon={true}
                                disabled={true}
                                isReadOnly={isReadOnly}
                                placeholder={"Search..."}
                                inputError={AuthorizationValidationModal.ProcedureCodeVal}
                            /> */}
                        </div>
                        {AuthorizationValidationModal.ProcedureCodeVal}
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input mb-0'>
                            <div className="d-flex justify-content-between">
                                <label>Additional CPT Code</label>
                                {<i className='icon-Clip-path-group' onClick={() => handleOpenCPTCode('AdditionalCPTCode')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentCPTs}
                                PatDxData={[]}
                                id='CPT'
                                name='AdditionalCPTCode'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.AdditionalCPTCode}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                                method='post'
                                postBody={cptBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={AuthorizationValidationModal.ProcedureCodeVal}
                                isItemSelected={!isNull(mainAuthorizationModal.AdditionalCPTCode) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                            {/* <SuperSearchList
                                type='server'
                                id='AdditionalCPTCode'
                                name='AdditionalCPTCode'
                                searchValue={mainAuthorizationModal.AdditionalCPTCode}
                                ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                                method='post'
                                postBody={cptBody}
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // icon={true}
                                disabled={true}
                                isReadOnly={isReadOnly}
                                placeholder={"Search..."}
                            /> */}
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode1) ?
                                    <>
                                        {icd1}
                                    </> :
                                    <label>ICD1</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode1')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode1'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode1}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode1) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode2) ?
                                    <>
                                        {icd2}
                                    </> :
                                    <label>ICD 2</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode2')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode2'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode2}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode2) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode3) ?
                                    <>
                                        {icd3}
                                    </> :
                                    <label>ICD3</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode3')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode3'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode3}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode3) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode4) ?
                                    <>
                                        {icd4}
                                    </> :
                                    <label>ICD 4</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode4')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode4'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode4}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode4) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 mb-1">
                        <div className={AuthorizationValidationModal.AuthorizedUnitsVal ? 'form-group input error' : 'input form-group'}>
                            <label htmlFor="AuthorizeUnits">Total Authorized Units <span className='req'>*</span> </label>
                            <div className='input form-group'>
                                <input type="text"
                                    className='form-control'
                                    name="AuthorizeUnits"
                                    id="AuthorizeUnits"
                                    maxLength={50}
                                    autoComplete="off"
                                    onKeyPress={handleNumericCheck}
                                    value={mainAuthorizationModal.AuthorizeUnits}
                                    onChange={handleAuthorizationChange}
                                />
                            </div>
                            {AuthorizationValidationModal.AuthorizedUnitsVal}
                        </div>
                    </div>
                    <div className="col-md-3 mb-1">
                        <div className='input form-group'>
                            <label htmlFor="Frequency">Frequency</label>
                            <SuperSearchList
                                type="client"
                                id='Frequency'
                                name='Frequency'
                                searchValue={mainAuthorizationModal.Frequency}
                                data={AuthorizationFrequency}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                isReadOnly={AuthorizationID === 0 ? true : false}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 mb-1">
                        <div className={AuthorizationValidationModal.UnitsFrequencyVal ? 'form-group input error' : 'input form-group'}>
                            <label htmlFor="RemainingUnits">Units Per Frequency <span className='req'>*</span> </label>
                            <input type="text"
                                className='form-control'
                                name="UnitsFrequency"
                                id="UnitsFrequency"
                                autoComplete="off"
                                onKeyPress={(event) => handleNumericCheck(event)}
                                value={mainAuthorizationModal.UnitsFrequency}
                                onChange={handleAuthorizationChange}
                            />
                            {AuthorizationValidationModal.UnitsFrequencyVal}
                        </div>
                    </div>
                    <div className="col-md-3 d-flex flex-column justify-content-end gap-1">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text">Utitlized Units :</p>
                            <p className="heading Paid-clr">{mainAuthorizationModal.UtilizedUnits}</p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text">Remaining Units :</p>
                            <p className="heading Partialdenied-clr">{mainAuthorizationModal.RemainingUnits}</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className='input form-group'>
                            <label htmlFor="AuthorizationStatus">Status</label>
                            <SuperSearchList
                                type="client"
                                id='AuthorizationStatus'
                                name='AuthorizationStatus'
                                searchValue={mainAuthorizationModal.AuthorizationStatus}
                                data={AuthorizationStatus}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            // isReadOnly={AuthorizationID === 0 ? true : false}
                            />
                            {/* <select type="text"
                                className='form-control'
                                name="AuthorizationStatus"
                                id="AuthorizationStatus"
                                value={mainAuthorizationModal.AuthorizationStatus}
                                onChange={handleDropdwonChange}
                                disabled={AuthorizationID === 0 ? true : false}
                            >
                                {AuthorizationStatus.map((e, index) => (
                                    <option value={e.value} key={index}>
                                        {e.display}
                                    </option>
                                ))}
                            </select> */}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className='input form-group'>
                            <label htmlFor="AuthBasedOn">
                                Authorization Based On
                            </label>
                            <SuperSearchList
                                type="client"
                                id='AuthBasedOn'
                                name='AuthBasedOn'
                                searchValue={mainAuthorizationModal.AuthBasedOn}
                                data={[
                                    { display: 'Units', value: 'Units' },
                                    { display: 'Visits', value: 'Visits' },
                                ]}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                    </div>
                    <div className="col-md-6 mb-1">
                        <div className="input">
                            <label>Authorization Document</label>
                            {mainAuthorizationModal.FileName ? (
                                <div className='d-flex gap-3 align-items-center mt-1'>
                                    <p className='heading fst-italic validation_message'>{mainAuthorizationModal.FileName}
                                        {/* <span className='ms-1'> 30 KB</span> */}
                                    </p>
                                    <div className='d-flex align-items-center gap-2'>
                                        {isFileChanged ? null :
                                            <div className="hk-uploadFile__btns m-0">
                                                <button className="btn-icon-transparent icon-box" onClick={() => DownloadFile('AuthorizationDocument')}>
                                                    <i className="icon-upload-converted"></i>
                                                </button>
                                            </div>
                                        }
                                        <div className='ar-upload-btn' onClick={() => handleRemoveImage('AuthorizationDocument')}>
                                            <i className='icon-delete'></i>
                                        </div>
                                        {isFileChanged ? null :
                                            <button className='border-0 no-width bg-transparent' onClick={ViewPdf}>
                                                <span class="icon-pdf-followup fs-19"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span></span>
                                            </button>
                                        }
                                    </div>
                                </div>
                            ) : (
                                <div className='upload-file form-control'>
                                    <input
                                        type="file"
                                        accept=".pdf"
                                        id='AuthorizationDocument'
                                        name="AuthorizationDocument"
                                        onChange={handleImageChange}
                                    />
                                    <label htmlFor="AuthorizationDocument">
                                        <i className='bi bi-paperclip'></i>
                                        {mainAuthorizationModal.FileName ? mainAuthorizationModal.FileName : "Upload a File"}
                                    </label>
                                </div>
                            )}
                        </div>

                    </div>
                    <div className="form-group input col-md-12">
                        <label htmlFor="Description">Authorization Notes</label>
                        <textarea
                            className="form-control doc-textarea"
                            id="Notes"
                            name="Notes"
                            value={mainAuthorizationModal.Notes}
                            onChange={handleDropdwonChange}
                            rows={2}
                        ></textarea>
                    </div>
                </div >
                <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1">
                    <Modal.Body>
                        <div className="download-header">
                            <div className='hide-me'></div>
                            <button className="btn-icon-transparent" onClick={() => setModalActive(false)}>
                                <i className="icon-Icon-metro-cross"></i>
                            </button>
                        </div>
                        <div className="pdfView-box">

                            {!isNull(txtFile) ? txtFile : ''}
                            {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

                        </div>
                        {isLoading ? <Loader /> : null}

                        {pdfFile &&
                            <>
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                    <Viewer fileUrl={pdfFile}
                                        defaultScale={1}
                                        plugins={[defaultLayoutPluginInstance]} />
                                </Worker>
                            </>
                        }
                    </Modal.Body>
                    <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
                        <button className='btn btn-gray' onClick={() => setModalActive(false)}>Cancel</button>
                    </div>
                </Modal>
            </>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {ICDpopup}
            {ProcedureSerachPopup}
            {AuthrizedPopup}
            <Modal show={UpdateAuthorizationNumber} onHide={UpdateAuthorizationNumber} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za-exit-group za-update-subscriber-id za-update-authoriaztion">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className='paragraph d-flex gap-1'>
                        <i className='icon-Vector13 fs-16'></i>
                        <p className=' text fs-12 fst-italic'>You have {claimCounts} visits associated with the previous Authorization # [{previousAuthorizationNumber}]. Do you want to update the Authorization # [{NewAuthorizationNumber}] for these visits as well?</p>
                    </div>
                    <div className='za-button text-end'>
                        <button className='btn btn-cancel heading fs-12 px-10' onClick={handleAutorizedClose}> No</button>
                        <button className='btn btn-exit heading fs-12 px-10' onClick={handleAutorized}> Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {NewICDPopup}
                    {NewCPTPopup}
                    {isLoading ? <Loader /> : null}
                    <div className="add_autherization mb-2">
                        {AddnewAuth()}
                    </div>
                    {/* <ModalFooter isSaved={onInsuranceSave ? onDeleteInsurance : onClose} handleSave={handleSaveAuthorization} IsEditAllowed={IsEditAllowed} /> */}
                    {/* <div className={"btns-group text-end modal_footer br-top-1 br-clr d-flex justify-content-between flex-column flex-sm-row align-items-center gap-3"} > */}
                    <div className={"d-flex align-items-center pt-2 br-top-1 za_br_light justify-content-between ar_footer"} >
                        <div>
                            {DataImportMenu[1].status === 'true' ? <button className="btn btn-view px-2" onClick={() => handleProcessPendingData()}>Proccesed</button> : null}
                        </div>
                        {/* <div className="btns-group d-flex justify-content-center align-items-center">
                            <button className="btn btn-gray" onClick={onClose}>
                                Cancel
                            </button>

                            <button className={IsEditAllowed ? 'btn btn-orange ' : 'btn btn-orange disabled'} disabled={!IsEditAllowed} onClick={handleSaveAuthorization}>
                                Save
                            </button>
                        </div> */}

                        <div className="d-flex align-items-center gap-2">
                            <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                            <button className={IsEditAllowed ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} disabled={!IsEditAllowed} onClick={handleSaveAuthorization}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
                :
                <Modal show={IsOpenAuthorization} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_autherization modal-c-lg">
                    {AuditPopup}
                    {PopupScreen}
                    {NewICDPopup}
                    {NewCPTPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetAuthorizationName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onClose} key={2132} Name={'Authorization'} IsDeleteAllowed={IsDeleteAllowed} />
                        {isLoading ? <Loader /> : null}
                        {AddnewAuth()}
                    </Modal.Body>
                    <ModalFooter isSaved={onInsuranceSave ? onDeleteInsurance : onClose} handleSave={handleSaveAuthorization} IsEditAllowed={IsEditAllowed} />
                    {/* <ModalFooter isSaved={onInsuranceSave ? IsOpenAuthorization : onClose} handleSave={handleSaveAuthorization} /> */}
                </Modal>
            }
            {AuthorizationID === 0 ? <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal auth-proceed_npi_modal w-100">
                <Modal.Body>
                    {/* <SearchHeader masterListButton={proceedNPI} /> */}
                    <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                    <div className='container-fluid  br-clr'>
                        <div className="row">

                            <div className={`input px-2 mb-2 ${AuthFileValidation?.UploadedFile ? 'error' : ''}`}>
                                {OCRFileName ? (
                                    <div className='d-flex gap-3 align-items-center'>

                                        <div className="d-flex align-items-center gap-1">
                                            <div className="ar-pdf-icon d-flex justify-content-center align-items-center">
                                                <PdfIcon classes={'fs-11'} />
                                            </div>
                                            <div className="d-flex flex-column">
                                                <p className='heading font-m fs-11 validation_message npi-vald text-nowrap'>{OCRFileName}</p>
                                                {/* <span className='heading font-m fs-11 '> 30 KB</span> */}
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <div className='ar-upload-btn' onClick={() => handleRemoveImage('OCRFile')}>
                                                <i className='icon-delete fs-13'></i>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='upload-file form-control'>
                                        <input
                                            type="file"
                                            id='OCRFile'
                                            name="OCRFile"
                                            onChange={handleImageChangeOCR}
                                        />
                                        <label htmlFor="OCRFile">
                                            <i className='bi bi-paperclip'></i>
                                            {OCRFileName ? OCRFileName : "Upload a File"}
                                        </label>
                                    </div>
                                )}
                            </div>
                            <div className='input form-group'>
                                <SuperSearchList
                                    type="client"
                                    id='PatientInsuranceID'
                                    name='PatientInsuranceID'
                                    searchValue={mainAuthorizationModal.PatientInsuranceID}
                                    data={InsuranceListModal}
                                    onChange={handleDropdwonChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                />
                                {/* </div> */}
                                {AuthorizationValidationModal.InusranceIDVal}
                            </div>
                            <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry} >Proceed <i className="icon-arrow-right"></i></button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> : null}
        </React.Fragment>

    )
}

export default AddNewAuthForPractice